module.exports = __webpack_public_path__ + "static/media/wave-header.3024cb73.svg";